import { FC, useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

import Helmet from '@/components/meta/Helmet';
import OptimizeTag from '@/components/meta/OptimizeTag';
import SignupTemplate from '@/components/templates/SignUp';
import { INVITER_PARAM_KEY } from '@/config/constants/query';
import { useSetBreadcrumbContext } from '@/contexts/breadcrumb';
import { useLayoutContext } from '@/contexts/layout';
import { setInviterCookie } from '@/lib/invitation';

const Index: FC = () => {
  const { setLayoutStyles } = useLayoutContext();
  const setBreadcrumbs = useSetBreadcrumbContext();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const inviter = queryParams.get(INVITER_PARAM_KEY);

  useLayoutEffect(() => {
    setLayoutStyles({
      showBetButton: false,
    });
  }, []);

  useEffect(() => {
    setBreadcrumbs([
      {
        name: '登録までの3ステップ',
        to: '',
      },
    ]);
  }, []);

  if (inviter) {
    setInviterCookie(inviter);
  }

  return (
    <>
      <Helmet
        meta={{
          title: '会員登録 - 案内',
          description: '会員登録（案内）ページです。%s',
          keywords: '会員登録,%s',
        }}
      >
        <title>会員登録 - 案内</title>
      </Helmet>
      <OptimizeTag />
      <SignupTemplate />
    </>
  );
};

export default Index;
